import { Card } from '@mantine/core'
import CardClasses from './styles.module.css'
import '../../styles/variables.css'

export default Card.extend({
    defaultProps: {
        padding: 'var(--gm-spacing-24)',
        shadow: 'xs',
        radius: 'var(--gm-radius-16)',
        bg: 'var(--gm-gray-lighter)',
    },
    classNames: CardClasses,
})
